import { useBonusesCountStore } from '../../stores/useBonusesCountStore'
import { useAllBonusesGrid } from '../AllBonusesGrid/useAllBonusesGrid'

interface BonusesPageOptions {
  runClaimAnimation?: () => Promise<void> | void
}

export function useBonusesPage(options: BonusesPageOptions = {}) {
  const { t } = useI18n()
  const route = useRoute()
  const router = useRouter()
  const { runClaimAnimation } = options

  const { bonusesCount: myBonusesCount } = storeToRefs(useBonusesCountStore())
  const { extendedBonuses } = useAllBonusesGrid()

  const selectedTab = useRouteQuery<'my' | 'all'>('bonusTab', 'my')
  const bonusTabs = computed(() => [
    {
      id: 'my',
      label: t('bonuses.myBonusesTab'),
      counter: myBonusesCount.value,
    },
    {
      id: 'all',
      label: t('bonuses.allBonusesTab'),
      counter: extendedBonuses.value.length,
    },
  ])
  const tabBgStyle = computed(() =>
    selectedTab.value === 'my'
      ? {
          bgColor: 'ghost' as const,
          selectedColor: 'orange' as const,
        }
      : {
          bgColor: 'orange' as const,
          selectedColor: 'ghost' as const,
        },
  )

  const fromRegistration = computed(() => route.query.from === 'registration')

  onMounted(async () => {
    if (fromRegistration.value && runClaimAnimation) {
      await runClaimAnimation()
    }
  })

  function deleteAnimation() {
    const query = { ...route.query }
    if (query.from === 'registration') {
      delete query.from
      router.replace({ query })
    }
  }

  return {
    selectedTab,
    bonusTabs,
    tabBgStyle,
    deleteAnimation,
  }
}
